import { Message } from "element-ui";
import { Decimal } from "decimal.js";
const commonJS = {
    //价格的千位符处理
    formatThousand(num) {
        if (num != null) {
            var res = num.toString().replace(/\d+/, function(n) {
                // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
                    return $1 + ",";
                });
            });
            return res;
        }
        return num;
    },
    // 四舍五入保留n位小数
    formatFloat(num, n) {
        var f = parseFloat(num);
        if (isNaN(f)) {
            return "";
        } else {
            f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
            var s = f.toString();
            var rs = s.indexOf(".");
            // 判定是整数,增加小数点再补0
            if (rs < 0) {
                rs = s.length;
                s += ".";
            }
            while (s.length <= rs + n) {
                s += "0";
            }
            return s;
        }
    },
    // 乘法精确度缺失问题
    mul(num1, num2, n) {
        console.log("🚀 ~ file: common.js:39 ~ mul ~ num2:", num2)
        console.log("🚀 ~ file: common.js:39 ~ mul ~ num1:", num1)
        let value = new Decimal(num1).mul(new Decimal(num2));
        console.log("GY🚀 ~ mul ~ value:", value.toNumber());
        let result = value.toNumber().toFixed(n, Decimal.ROUND_HALF_UP)
        console.log('乘法____result.toNumber()', result)
        return result;
    },
    // 加法精确度缺失问题
    add(args, n) {
        console.log("🚀 ~ file: common.js:141 ~ add ~ args", args)
        let result = new Decimal(args[0]);
        for (let i = 1; i < args.length; i++) {
            result = result.add(new Decimal(args[i]));
        }
        console.log('加法____result.toNumber()', result.toNumber().toFixed(n, Decimal.ROUND_HALF_UP))
        return result.toNumber().toFixed(n, Decimal.ROUND_HALF_UP);
    },
    // 减法精确度缺失问题
    sub(num1, num2, n) {
        console.log("🚀 ~ file: common.js:58 ~ sub ~ num2:", num2)
        console.log("🚀 ~ file: common.js:58 ~ sub ~ num1:", num1)
        let value = new Decimal(num1).sub(new Decimal(num2));
        let result = value.toNumber().toFixed(n, Decimal.ROUND_HALF_UP)
            // let result = new Decimal(args[0]);
            // for (let i = 1; i < args.length; i++) {
            //     result = result.sub(new Decimal(args[i]));
            // }
        console.log('减法____result.toNumber()', result)
        return result;
    },
    // 除法精确度缺失问题
    div(num1, num2, n) {
        console.log("🚀 ~ file: common.js:67 ~ div ~ n:", n)
        console.log("🚀 ~ file: common.js:67 ~ div ~ num2:", num2)
        console.log("🚀 ~ file: common.js:67 ~ div ~ num1:", num1)
        let value = new Decimal(num1).div(new Decimal(num2));
        let result = value.toNumber().toFixed(n, Decimal.ROUND_HALF_UP)
            // for (let i = 1; i < args.length; i++) {
            //     result = result.div(new Decimal(args[i]));
            // }
        console.log('除法____result.toNumber()', result)
        return result;
    },
    // 集中校验提示
    centralizedValid(validData, h) {
        // console.log("validData", validData);
        // console.log("h", h);
        if (validData.length > 0) {
            var reg = /^.{1,1000}$/;
            var arr = [];
            var newTips = [];
            validData.forEach((ele) => {
                // 判断是否需要校验必填
                if (ele.format.indexOf("required") > -1) {
                    if (!ele.prop) {
                        arr.push("请输入" + ele.label);
                    }
                }
                // 校验长度不得大于1000个字符
                if (ele.format.indexOf("validLengthThousand") > -1) {
                    if (ele.prop && !reg.test(ele.prop)) {
                        arr.push(
                            ele.label + "字段已超过系统限制的最大长度1000个字符，请检查."
                        );
                    }
                }
            });
            if (arr.length > 0) {
                for (const i in arr) {
                    newTips.push(h("p", null, arr[i]));
                }
                Message.error({
                    dangerouslyUseHTMLString: true,
                    message: h("div", null, newTips),
                });
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
    // 列表集中校验提示
    validTable(filterArr, h) {
        console.log("filterArr", filterArr);
        console.log("h", h);
        var newTips = [];
        if (filterArr.length > 0) {
            for (const i in filterArr) {
                newTips.push(h("p", null, filterArr[i]));
            }
            Message.error({
                dangerouslyUseHTMLString: true,
                message: h("div", null, newTips),
            });
            return false;
        } else {
            return true;
        }
    },
    // el-input输入时只能输入正数且最多保留N位小数
    handleInput(value, maxDecimalDigits) {
        // 1. 过滤非法字符（仅保留数字和小数点）
        let filtered = value.replace(/[^\d.]/g, '');
        console.log("过滤非法字符（仅保留数字和小数点）:", filtered);
        // 2. 禁止以小数点开头
        if (filtered.startsWith('.')) {
            inputValue = '';
            return;
        }
        // 3. 处理多个小数点（保留第一个）
        if ((filtered.match(/\./g) || []).length > 1) {
            const firstDotIndex = filtered.indexOf('.');
            filtered = filtered.slice(0, firstDotIndex + 1) +
                filtered.slice(firstDotIndex + 1).replace(/\./g, '');
        }
        console.log("处理多个小数点（保留第一个）:", filtered);
        // 4. 分割整数和小数部分
        const [integerPart, decimalPart = ''] = filtered.split('.');
        console.log("分割整数和小数部分 ~ 小数:", decimalPart);
        console.log("分割整数和小数部分 ~ 整数:", integerPart);
        // 5. 截断超过6位的小数部分（不四舍五入）
        const truncatedDecimal = decimalPart.slice(0, maxDecimalDigits);
        console.log("截断超过6位的小数部分（不四舍五入）:", truncatedDecimal);
        const processedValue = decimalPart.length > 0 ? `${integerPart}.${truncatedDecimal}` : integerPart;
        console.log("GY🚀 ~ handleInput ~ processedValue:", processedValue);
        // 6. 最终格式验证（整数部分存在且为数字）
        const pattern = new RegExp(`^\d+\.?\d{0,${maxDecimalDigits}}$`);
        console.log("动态正则校验:", pattern);
        const isValid = pattern.test(processedValue) && !/^0+$/.test(integerPart); // 禁止全零整数部分
        console.log("GY🚀 ~ handleInput ~ isValid:", isValid);
        let inputValue = null
        inputValue = isValid ? processedValue : '';
        console.log("最终值:", inputValue);
        return inputValue
    }
};

export default commonJS;